import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AmountPaymentPlanPage } from './amount-payment-plan.page';

const routes: Routes = [
  {
    path: '',
    component: AmountPaymentPlanPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AmountPaymentPlanPageRoutingModule {}
